export const academyLogsAdapter = (data) => {
  if (!data) {
    return [];
  }

  const newArr = [];

  const prepareData = (i) => ({
    ...i,
    'shopping_centers.title': i?.academy_article?.shopping_center?.title,
    'users.name': i?.user?.surname_name,
    'academy_articles.macro_area': i?.academy_article?.macro_area,
    'academy_categories.year': i?.academy_article?.academy_category?.year,
    'academy_categories.title': i?.academy_article?.academy_category?.title,
    'academy_articles.title': i?.academy_article?.title,
  });

  if (Array.isArray(data)) {
    data.forEach((i) => {
      newArr.push(prepareData(i));
    });

    return newArr;
  }

  return prepareData(data);
};
